import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import MarketSelect from 'src/components/form-elements/market-select.dashboard.component';
import { connect } from 'react-redux';
import { selectUserOrganization, selectUserMarketIds } from 'src/redux/user/user.selectors';
import {
  TodoList,
  SalesOverview,
  LandedCostInView,
  OrdersPendingForVin,
  VinsBelowLandedCost,
  UsedCarStock,
  CarSwap,
  RvToLcDifference,
} from "src/components/dashboard/index.js";
import { makeStyles } from '@material-ui/core/styles';

const UseStyles = makeStyles({
  root: {
    overflow: 'auto', height: '96vh', backgroundColor: 'transparent', marginTop: '-10px', padding: '40px 0 10px 0',
    "&::-webkit-scrollbar": {
      height: "6px",
      width: "0.1px",
      opacity: "0.3",
      backgroundColor: 'rgb(19 19 19/ 1%)'
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "100px",
      backgroundColor: 'rgb(19 19 19/ 1%)',
      border: 'none'
    },
  },
});

const RemarketingDashboard = ({ userOrg, userMarketIds }) => {
  const classes = UseStyles();

  const [isMarketSelected, setIsMarkedSelected] = useState(false)

  let selectedMarket = userMarketIds.toString()

  let marketId = 'ALL'

  const handleChange = (event, markets) => {
    const { name, value } = event.target;
    let orgsMarkets = [];
    marketId = value.split('#')[0];
    let marketNmae = value.split('#')[1];

    if (marketId == 'ALL') { selectedMarket = userMarketIds }
    else {
      selectedMarket = [marketId]
      setIsMarkedSelected(true)
    }
  }

  return (
    <div className={classes.root}>
      <div style={{ marginTop: '30px', width: '15%' }}>
        <MarketSelect
          orgId={userOrg.id}
          value={selectedMarket.value}
          userMarketIds={userMarketIds}
          handleChange={handleChange}
        />
      </div>
      {/* --------------------------------------------------------------------------------*/}
      {/* Row-1                                                                          */}
      {/* --------------------------------------------------------------------------------*/}
      <Row>
        <Col lg="4" md="12" >
          <OrdersPendingForVin />
        </Col>
        <Col lg="4" md="12">
          <LandedCostInView />
        </Col>
        <Col lg="4" md="12">
          <VinsBelowLandedCost />
        </Col>
      </Row>
      {/* --------------------------------------------------------------------------------*/}
      {/* Row-2                                                                          */}
      {/* --------------------------------------------------------------------------------*/}
      <Row>
        <Col lg="4" md="12" >
          <UsedCarStock />
        </Col>
        <Col lg="4" md="12" >
          <CarSwap />
        </Col>
        <Col lg="4" md="12" >
          <RvToLcDifference />
        </Col>
      </Row>
      {/* --------------------------------------------------------------------------------*/}
      {/* Row-3                                                                          */}
      {/* --------------------------------------------------------------------------------*/}
      <Row>
        <Col lg="6" md="12" xl="6" className="col-xlg-6">
          <SalesOverview />
        </Col>
        <Col lg="6" md="12" xl="6" className="col-xlg-6">
          <div >
            <TodoList />
          </div>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = state => ({
  userOrg: selectUserOrganization(state),
  userMarketIds: selectUserMarketIds(state)
});

export default connect(mapStateToProps, null)(RemarketingDashboard);